import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initials: 'MG',
    quote: 'Organicé todo el año en una tarde. Las plantillas me ahorran horas cada semana. Por fin siento que tengo el control.',
    author: 'Mariela G.',
    role: 'docente de primaria, San José',
    color: 'bg-emerald-100 text-emerald-700'
  }, {
    initials: 'LP',
    quote: 'Los protocolos de disciplina por fin me funcionan. Llevo semanas sin gritar y el grupo está mucho más ordenado.',
    author: 'Laura P.',
    role: 'docente de secundaria, Heredia',
    color: 'bg-blue-100 text-blue-700'
  }, {
    initials: 'RM',
    quote: 'El tomo de salud mental me cambió la vida. Por primera vez en años, el domingo no me genera ansiedad.',
    author: 'Roberto M.',
    role: 'docente del MEP, Alajuela',
    color: 'bg-amber-100 text-amber-700'
  }];
  return <section className="py-16 px-4 bg-stone-50" data-id="element-304">
      <div className="max-w-6xl mx-auto" data-id="element-305">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-306">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-stone-100 flex flex-col h-full" data-id="element-307">
              <div className="flex items-center gap-3 mb-4" data-id="element-308">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${t.color}`} data-id="element-309">
                  {t.initials}
                </div>
                <div data-id="element-310">
                  <div className="flex text-amber-400 mb-1" data-id="element-311">
                    {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-312" />)}
                  </div>
                </div>
              </div>
              <p className="text-stone-600 italic mb-6 flex-grow" data-id="element-313">
                "{t.quote}"
              </p>
              <div className="text-sm" data-id="element-314">
                <span className="font-bold text-stone-900" data-id="element-315">— {t.author}</span>
                <span className="text-stone-500 block" data-id="element-316">{t.role}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}